/*
  Horizon Variant Image Fix — Final Version
  
  CONFIRMED from console:
  - Event: 'variant:selected' fires with { resource: {...} }
  - Images ARE assigned to variants in Shopify admin ✓
  
  HOW TO INSTALL:
  Upload to Assets, then in layout/theme.liquid before </body>:
  <script src="{{ 'variant-image-fix.js' | asset_url }}" defer></script>
*/
(function(){

  /* ── Find the media gallery element ── */
  function getGallery(){
    return document.querySelector(
      'media-gallery, product-media-gallery, [data-media-gallery], .product__media-gallery'
    );
  }

  /* ── Extract variant from Horizon's event detail ── */
  function getVariantFromDetail(detail){
    if(!detail) return null;
    var r = detail.resource || detail;
    /* Horizon's resource object — try all known locations */
    return r.selectedVariant
        || r.selected_variant
        || r.variant
        || (r.product && r.product.selectedVariant)
        || (r.product && r.product.selected_variant)
        || null;
  }

  /* ── Main swap function ── */
  function swapImage(variant){
    if(!variant) return;

    var fi = variant.featured_image || variant.featuredImage;
    if(!fi){
      /* No image assigned — nothing to swap */
      return;
    }

    var mediaId = String(fi.media_id || fi.mediaId || fi.id || '');
    var gallery  = getGallery();
    if(!gallery) return;

    /* ── Method 1: Horizon's internal select event on the gallery ── */
    if(mediaId){
      gallery.dispatchEvent(new CustomEvent('media:select', {
        bubbles: true,
        detail: { mediaId: mediaId }
      }));
    }

    /* ── Method 2: call the gallery's own select method if it exists ── */
    if(typeof gallery.select === 'function'){
      gallery.select(mediaId);
    }
    if(typeof gallery.setActiveMedia === 'function'){
      gallery.setActiveMedia(mediaId);
    }

    /* ── Method 3: find the slide by data-media-id and click its thumbnail ── */
    if(mediaId){
      /* Thumbnail strip (Horizon renders thumbnails beside the main image) */
      var thumb = document.querySelector(
        '[data-media-thumbnail-id="'+mediaId+'"], '+
        '[data-thumbnail-media-id="'+mediaId+'"], '+
        '.media-gallery__thumbnail[data-media-id="'+mediaId+'"], '+
        '[data-testid="media-thumbnail-'+mediaId+'"]'
      );
      if(thumb){ thumb.click(); return; }

      /* Main slide itself */
      var slide = gallery.querySelector('[data-media-id="'+mediaId+'"]');
      if(slide){
        slide.click();
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        return;
      }
    }

    /* ── Method 4: match by image src (filename) ── */
    if(fi.src){
      /* Extract base filename without size suffix and query string
         e.g. "yellow_heart_dress_abc123.jpg" */
      var rawSrc  = fi.src.split('?')[0];
      var parts   = rawSrc.split('/');
      var filename = parts[parts.length - 1];
      /* Remove Shopify size suffix like _800x800 */
      var baseName = filename.replace(/_\d+x(\d+)?(\.\w+)$/, '$2')
                              .replace(/\.\w+$/, '');

      var allSlides = gallery.querySelectorAll('[data-media-id]');
      for(var i = 0; i < allSlides.length; i++){
        var img = allSlides[i].querySelector('img');
        if(!img) continue;
        var imgSrc = (img.src || img.getAttribute('data-src') || '').split('?')[0];
        if(imgSrc && imgSrc.indexOf(baseName) !== -1){
          allSlides[i].click();
          allSlides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          return;
        }
      }
    }
  }

  /* ── Listen for Horizon's variant:selected event ── */
  document.addEventListener('variant:selected', function(e){
    var variant = getVariantFromDetail(e.detail);
    if(variant) swapImage(variant);
  });

  /* ── Also listen on variant:update (fires after selected with full data) ── */
  document.addEventListener('variant:update', function(e){
    if(!e.detail) return;
    var variant = getVariantFromDetail(e.detail);
    if(variant && (variant.featured_image || variant.featuredImage)){
      swapImage(variant);
    }
  });

  /* ── Fallback: watch URL for ?variant= changes ── */
  var lastVid = new URLSearchParams(location.search).get('variant');

  function onUrlVariantChange(){
    var vid = new URLSearchParams(location.search).get('variant');
    if(!vid || vid === lastVid) return;
    lastVid = vid;

    /* Find variant in product JSON */
    var jsonEl = document.querySelector(
      'script[type="application/json"][data-resource-type="product"], '+
      'script[type="application/json"][data-product-id], '+
      '#ProductJson-product-template, #product-json'
    );
    if(!jsonEl) return;
    try{
      var data = JSON.parse(jsonEl.textContent);
      var variants = data.variants || (data.product && data.product.variants) || [];
      var v = variants.find(function(v){ return String(v.id) === vid; });
      if(v) swapImage(v);
    }catch(e){}
  }

  /* Poll URL — lightweight, stops itself after 10s of no change */
  var pollTimer = setInterval(function(){
    onUrlVariantChange();
  }, 80);
  setTimeout(function(){ clearInterval(pollTimer); }, 10000);
  /* Re-start polling on any click */
  document.addEventListener('click', function(){
    clearInterval(pollTimer);
    pollTimer = setInterval(onUrlVariantChange, 80);
    setTimeout(function(){ clearInterval(pollTimer); }, 5000);
  }, { passive: true });

})();